export const getInitials = (name) => {
  try {
    const emojiRE = /(\p{Emoji_Presentation}|\p{Extended_Pictographic})/gu
    const names = name.replace(emojiRE, '').trim().split(' ')
    if (names.length === 1) {
      return names[0][0].toUpperCase()
    }
    return (names[0][0] + names.slice(-1)[0][0]).toUpperCase()
  } catch (error) {
    return ''
  }
}
